import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./JoinTeamSection.module.scss";


export const JoinTeamSection: React.FC = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>

        <div className={styles.content}>
          <div className={styles.textCol}>
            <span className={styles.tag}>Join our team ✋</span>
            <h2 className={styles.title}>
              We're building AI inbound revenue agents for growth teams
            </h2>
            <p className={styles.text}>
              Our mission is to create the best experience for customers of B2B
              companies — where every inbound conversation turns into a qualified
              lead, a booked meeting, or a loyal customer.
            </p>
            <p className={styles.text}>
              We started with a team of 4 in 2014. Now there are over 80,
              enthusiastic and persistent, willing to create and think big. We
              are united by our values, principles, and ideas.
            </p>
          </div>

          <div className={styles.foundersCol}>
            <div className={styles.foundersGrid}>
              <div className={styles.founderCard}>
                <div className={styles.photo}>
                  <StaticImage
                    src="../../../images/about-us/Dimitri Ive.png"
                    alt="Dimitri Ive — CEO & Co-founder"
                    width={120}
                    height={120}
                    placeholder="blurred"
                  />
                </div>
                <p className={styles.founderName}>Dimitri Ive</p>
                <p className={styles.founderRole}>CEO & Co-founder</p>
              </div>

              <div className={styles.founderCard}>
                <div className={styles.photo}>
                  <StaticImage
                    src="../../../images/about-us/Dima Turovski.png"
                    alt="Dima Turovski — Head of Product"
                    width={120}
                    height={120}
                    placeholder="blurred"
                  />
                </div>
                <p className={styles.founderName}>Dima Turovski</p>
                <p className={styles.founderRole}>Head of Product</p>
              </div>

              <div className={styles.founderCard}>
                <div className={styles.photo}>
                  <StaticImage
                    src="../../../images/about-us/Sergey Inkov.png"
                    alt="Sergey Inkov — CTO & Co-founder"
                    width={120}
                    height={120}
                    placeholder="blurred"
                  />
                </div>
                <p className={styles.founderName}>Sergey Inkov</p>
                <p className={styles.founderRole}>CTO & Co-founder</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default JoinTeamSection;
